import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ACCESS_API } from "./apiRoutes";

interface UseGetCurrentUserPermissionProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCurrentUserPermission = async (communityId: string) =>
  await axiosAuth.get(`${ACCESS_API}/community/${communityId}/current-user`);

const useGetCurrentUserPermission = ({
  communityId,
  queryParams,
}: UseGetCurrentUserPermissionProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["current-user-permission", communityId],
    queryFn: () => getCurrentUserPermission(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCurrentUserPermission;
